<template>
    <div class="more" @click="$emit('more')">
<img src="https://www.xaryxx.com/images/more.png" alt="" srcset="">
查看更多
      <!-- <div class="btn-text">
        
        查看更多 〉</div> -->
    </div>
</template>

<script>
    export default {
        name: "more-buttom"
    }
</script>

<style lang="less" scoped>
  .more{
    // width: 120px;
    // height: 40px;
    // line-height: 40px;
    // text-align: center;
    // background-color: #ffffff;
    // border: solid 1px #dddddd;
    // border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width: 35px;
      margin-right: 10px;
    }
    font-size: 20px;
font-family: PingFang SC-Regular, PingFang SC;
font-weight: 400;
color: #999999;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/more-button.vue